import type { HTMLAttributes, ReactNode } from "react"
import { cn } from "@/lib/cn"

// Pill / chip element used for status, category, count badges.
// Tone maps to brand intent — never specify hex in callers.
export type BadgeTone = "gold" | "red" | "neutral" | "success" | "warning" | "error"

const TONE: Record<BadgeTone, string> = {
  gold:    "border-vip-gold/30 bg-vip-goldMute text-vip-goldSoft",
  red:     "border-brand-red/30 bg-brand-redSoft text-brand-red",
  neutral: "border-border bg-white/5 text-app-text",
  success: "border-status-success/30 bg-status-success/10 text-status-success",
  warning: "border-status-warning/30 bg-status-warning/10 text-status-warning",
  error:   "border-status-error/30 bg-status-error/10 text-status-error",
}

type Props = HTMLAttributes<HTMLSpanElement> & {
  tone?: BadgeTone
  children: ReactNode
}

export function Badge({ tone = "neutral", className, children, ...rest }: Props) {
  return (
    <span
      {...rest}
      className={cn(
        "inline-flex items-center rounded-chip border px-2.5 py-1 text-xs font-medium",
        TONE[tone],
        className,
      )}
    >
      {children}
    </span>
  )
}
